import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 1.2rem;
`

// Aparência vem do padrão global de selects (globalStyle.ts). Aqui só limitamos
// a largura, porque o padrão global aplica width: 100% e o select acabava
// espremendo o botão ao lado.
export const StatusFilter = styled.select`
  width: 11rem;
  flex-shrink: 0;
`

export const NewOrderButton = styled.button`
  font-weight: bold;
  display: flex;
  gap: 0.4rem;
  align-items: center;
  height: 2rem;
  font-size: 0.72rem;
  padding: 0 0.9rem;
  color: #fff;
  cursor: pointer;
  background-color: #0090d3;
  border: none;
  border-radius: 2rem;
  white-space: nowrap;
  flex-shrink: 0;
`

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 1.2rem;
`

export const TableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 1.2rem;
`

export const StatusBadge = styled.span<{ $status: string }>`
  font-size: 0.65rem;
  font-weight: 600;
  border-radius: 1rem;
  padding: 0.2rem 0.7rem;
  white-space: nowrap;
  background-color: ${(props) => {
    switch (props.$status) {
      case 'EM_COTACAO':
        return '#fff6d9'
      case 'APROVADO':
        return '#efe3fb'
      case 'PEDIDO_EMITIDO':
        return '#e6f4fb'
      case 'RECEBIDO':
        return '#e3f7e9'
      default:
        return '#f0f0f0'
    }
  }};
  color: ${(props) => {
    switch (props.$status) {
      case 'EM_COTACAO':
        return '#9d7d07'
      case 'APROVADO':
        return '#6b3fa0'
      case 'PEDIDO_EMITIDO':
        return '#0090d3'
      case 'RECEBIDO':
        return '#2e8b4f'
      default:
        return '#696969'
    }
  }};
`

export const EmptyState = styled.div`
  padding: 3rem;
  text-align: center;
  color: #969696;
  font-size: 0.8rem;
`

export const ViewToggleGroup = styled.div`
  display: flex;
  border: 1px solid #dcdcdc;
  border-radius: 0.4rem;
  overflow: hidden;
`

export const ViewToggleButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  height: 2rem;
  padding: 0 0.8rem;
  font-size: 0.72rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  color: ${(props) => (props.$isActive ? '#fff' : '#696969')};
  background-color: ${(props) => (props.$isActive ? '#0090d3' : '#fff')};
  transition: background-color 0.12s, color 0.12s;

  & + & {
    border-left: 1px solid #dcdcdc;
  }

  &:hover {
    background-color: ${(props) => (props.$isActive ? '#0090d3' : '#f5f5f5')};
  }
`

export const Card = styled.div<{ $clickable?: boolean }>`
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.45rem;
  padding: 0.85rem 1rem;
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
  transition: box-shadow 0.15s, border-color 0.15s;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    ${(props) =>
      props.$clickable &&
      `
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
      border-color: #a8d8ee;
    `}
  }
`

export const CardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`

export const CardTopActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
`

export const CardTitle = styled.div`
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.3;
  color: #000;
`

export const CardId = styled.div`
  font-size: 0.62rem;
  color: #999;
  font-weight: 600;
  margin-top: 0.15rem;
`

export const CardDesc = styled.div`
  font-size: 0.68rem;
  color: #696969;
  line-height: 1.5;
  margin-bottom: 0.6rem;
`

export const CardMeta = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  font-size: 0.65rem;
  padding: 0.5rem 0;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0.6rem;
`

export const CardMetaItem = styled.div``

export const CardMetaLabel = styled.div`
  font-size: 0.55rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 600;
`

export const CardMetaValue = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: #000;
  margin-top: 0.05rem;
`

export const CardFoot = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CardTypeTag = styled.span<{ $type: string }>`
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.6rem;
  border-radius: 2rem;
  font-size: 0.58rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background-color: ${(props) => (props.$type === 'INDUSTRIALIZACAO' ? '#ffedd5' : '#dbeafe')};
  color: ${(props) => (props.$type === 'INDUSTRIALIZACAO' ? '#9a3412' : '#1e40af')};
`

export const CardValue = styled.span`
  font-size: 0.85rem;
  font-weight: 800;
  color: #0090d3;
`

export const BoardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 0.85rem;
  padding-bottom: 1rem;
`

export const KanbanWrapper = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: stretch;
  padding-bottom: 1rem;
`

export const KanbanColumn = styled.div<{ $isOver: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 0 0 255px;
  min-width: 255px;
  border-radius: 0.45rem;
  overflow: hidden;
  background-color: ${({ $isOver }) => ($isOver ? '#eef6fb' : 'transparent')};
  transition: background-color 0.12s;
`

export const KanbanColHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 0.7rem;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
`

export const KanbanColTitle = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  color: #3a3a3a;
  flex: 1;
`

export const KanbanColCount = styled.span`
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 9999px;
  background-color: #eef6fb;
  color: #0f3f59;
  font-size: 0.7rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const KanbanColBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  overflow-y: auto;
  padding: 0.35rem 0 0;
`

export const KanbanCardSlot = styled.div<{ $locked?: boolean }>`
  width: 100%;
  cursor: ${(props) => (props.$locked ? 'not-allowed' : 'grab')};

  &:active {
    cursor: ${(props) => (props.$locked ? 'not-allowed' : 'grabbing')};
  }

  ${(props) =>
    props.$locked &&
    `
    opacity: 0.55;
    filter: grayscale(35%);
  `}
`
